import { useState } from 'react'
import { ColorButton } from './ui/ColorButton'
import { TransparencySlider } from './TransparencySlider'
import { LayerControl } from './LayerControl'
import { DeleteButton } from './ui/DeleteButton'
import { LockButton } from './ui/LockButton'
import { UnlockButton } from './ui/UnlockButton'
import { NumberInput } from './ui/NumberInput'
import Divider from '@mui/joy/Divider'

export const AdminObjectGrid = ({
    onOpacityChange,
    onFillColorChange,
    onDelete,
    onLayerUp,
    onLayerDown,
    onLockToggle,
    onBorderWidthChange,
    onBorderColorChange,
    obj,
    children,
}) => {
    const OPACITY = obj.opacity * 100
    const [fillColor, setFillColor] = useState(obj.fill)
    const [isLocked, setIsLocked] = useState(obj.lockScalingX)
    const [borderWidth, setBorderWidth] = useState(obj.strokeWidth)
    const [borderColor, setBorderColor] = useState(obj.stroke || '#000000')

    const handleOpacityChange = (e) => {
        let value = e.target.value
        let newOpacity = Number(value) / 100
        onOpacityChange({ obj, value: newOpacity })
    }

    const handleFillColorChange = (color, event) => {
        console.log(color)
        let value = color.hex
        setFillColor(value)
        onFillColorChange({ obj, value })
    }

    const handleLockToggle = (e) => {
        setIsLocked(!isLocked)
        onLockToggle(obj)
    }

    const handleBorderWidthChange = (value) => {
        setBorderWidth(value)
        onBorderWidthChange({ obj, value })
    }

    const handleBorderColorChange = (color, event) => {
        let value = color.hex
        setBorderColor(value)
        onBorderColorChange({ obj, value })
    }

    return (
        <>
            <TransparencySlider
                onChange={handleOpacityChange}
                opacity={OPACITY}
            />
            <ColorButton
                onChange={handleFillColorChange}
                currentColor={fillColor}
            />
            <LayerControl
                onLayerUp={() => onLayerUp(obj)}
                onLayerDown={() => onLayerDown(obj)}
            />
            {isLocked ? (
                <UnlockButton onClick={handleLockToggle} />
            ) : (
                <LockButton onClick={handleLockToggle} />
            )}
            {children}
            <Divider>Border Controls</Divider>
            <NumberInput
                label="Border Width"
                onChange={handleBorderWidthChange}
                min={0}
                max={100}
                step={1}
                value={borderWidth}
            />
            <ColorButton
                onChange={handleBorderColorChange}
                currentColor={borderColor}
            />
            <DeleteButton onClick={() => onDelete({ obj })} />
        </>
    )
}
